"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductConfigAlgolia = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var main_1 = require("../../../../../../reducers/slices/main");
var react_redux_1 = require("react-redux");
var react_2 = require("@nextui-org/react");
var react_3 = require("@iconify/react");
var index_products_1 = require("../../../../../../api/calls/integration/algolia/index_products");
var constants_1 = require("../../../../../../constants/constants");
var useSearchDebounce_1 = require("../../../../../../hooks/useSearchDebounce");
var branch_list_thunk_1 = require("../../../../../../reducers/slices/branch/thunks/get/branch_list_thunk");
var ProductConfigAlgolia = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var branches = (0, react_redux_1.useSelector)(function (state) { return state.branchState; }).branches;
    var _a = (0, useSearchDebounce_1.useSearchDebounce)(), branchSearch = _a[0], setBranchSearch = _a[1];
    var _b = (0, react_1.useState)(null), branch = _b[0], setBranch = _b[1];
    var selectedProducts = (0, react_redux_1.useSelector)(function (state) { return state.productState; }).selectedProducts;
    (0, react_1.useEffect)(function () {
        if (!branches.length)
            dispatch((0, branch_list_thunk_1.branch_list_thunk)({}));
    }, []);
    (0, react_1.useEffect)(function () {
        getBranches();
    }, [branchSearch]);
    var getBranches = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch((0, branch_list_thunk_1.branch_list_thunk)({ search_string: branchSearch }))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); };
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, success, message, content;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, index_products_1.index_products)({
                        products: selectedProducts.map(function (x) { return ({
                            objectID: x._id,
                            title: x.title,
                            sub_title: x.sub_title,
                            image_url: x.image_url,
                            description: x.description,
                            price: x.price,
                            tags: x.tags,
                            brand: x.brand,
                            manufacturer: x.manufacturer,
                            sku: x.sku,
                        }); }),
                        branch_id: branch === null || branch === void 0 ? void 0 : branch._id,
                    })];
                case 1:
                    _a = _b.sent(), success = _a.success, message = _a.message, content = _a.content;
                    if (success) {
                        dispatch((0, main_1.setContentModal)(null));
                        dispatch((0, main_1.setMessageModal)({ title: "Success", messages: [message] }));
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: constants_1.REQUEST_ERROR_TITLE, messages: [message] }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [branches && branches.length > 0 && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.DropdownSearchControl, { label: "Select Branch", onSearchChanged: function (search_string) {
                        setBranchSearch(search_string);
                    }, options: branches.map(function (x) {
                        return {
                            _id: x._id,
                            display_name: x.display_name,
                        };
                    }), renderDisplay: function (_) { return "".concat(_.display_name); }, value: branch, onChange: function (branch) {
                        setBranch(branch);
                    } }) })), (0, jsx_runtime_1.jsx)("ul", __assign({ className: "flex flex-col gap-4 max-h-96 overflow-auto p-4 mt-4  h-4/5" }, { children: selectedProducts &&
                    selectedProducts.map(function (x) { return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: "flex gap-8 border-b border-borders pb-2" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "" }, { children: (0, jsx_runtime_1.jsx)("img", { className: "w-10 aspect-square rounded-lg", src: x === null || x === void 0 ? void 0 : x.image_url }) })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: x === null || x === void 0 ? void 0 : x.title })] }))); }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-center" }, { children: (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ className: "bg-primary text-white", endContent: (0, jsx_runtime_1.jsx)(react_3.Icon, { className: "text-white", icon: "solar:alt-arrow-right-linear" }), size: "sm", variant: "flat", onClick: submit }, { children: "Push" })) }))] })));
};
exports.ProductConfigAlgolia = ProductConfigAlgolia;
